<template>
  <section>
    <span class="title is-justify-content-center is-flex">
      Админ-Панель
    </span>

    <ul class="hero subtitle" style="margin: 10%; list-style: disc outside;line-height: 150%">
      <li>
        <Link url="https://felicita.kz" name="Открыть сайт"/>
      </li>

      <li>Все картинки должны пройти через
        <Link url="https://tinypng.com" name="этот сервис"/>
      </li>
      <li>Размер баннера - <b>930x350</b></li>
      <li>Размер карточки (блюда или комбо) - любой <u><b>квадратный</b></u>, но не менее <b>390x390</b></li>
      <li>
        <Link url="https://metrika.yandex.ru/list" name="Яндекс Метрика"/>
      </li>
      <li>
        <Link url="https://analytics.google.com/analytics/web/" name="Google Analytics"/>
      </li>
    </ul>
  </section>
</template>

<script>
import Link from "../components/Link";

export default {
  name: 'Home',
  components: {Link}
}
</script>
